import React from 'react';

const WeatherPage = () => {
  return <div>天気の確認</div>;
};

export default WeatherPage;
